import React, { useState } from "react";

const industryOptions = [
  {
    label: "Agriculture & Environment Services",
    options: [
      "Agriculture, Forest, Fishing",
      "Animal Rescue",
      "Organic Crop Farming",
    ],
  },
  {
    label: "Business & Professional Services",
    options: [
      "Advertising Agencies",
      "Business Analytics",
      "Business Intelligence Software",
      "Collaboration Software",
      "Digital Advertising Agencies",
      "Market Research",
      "Marketing Consultants",
      "Scientific and Economic Consulting",
      "Search Engines",
      "SEO & Internet Marketing",
      "Web Design"

    ],
  },
  {
   label: "Community & Public Support Services",
    options: [
      "Community Food Services",
      "Community Housing",
       "Natural Disaster"
    ]
  },
  {
  label: "Education & Workforce Training",
    options: [
      "Educational Services",
      "Job Training",
      "Testing and Educational Support",
    ]
  },
  {
    label: "Health & Human Services",
    options: [
    "Adoption & Child",
    "Elderly & Disabled Services",
    "Family Counseling",
    "Health and Welfare",
    "Healthcare and Social Assistance",
    "Mental Health and Substance Abuse",
    "Psychologists Social Workers",
    "Residential Intellectual Disabilities",
    "Retirement Communities"
  ],
  },
  {
    label: "Science and Research",
    options: [
      "Biotechnology",
      "Scientific Research",
    ]
  }
];

const IndustryMultiSelect = ({ value = [], onChange }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleSelect = (option) => {
    const updated = value.includes(option)
      ? value.filter((item) => item !== option)
      : [...value, option];
    onChange(updated);
  };

  return (
    <div className="w-[70%] relative">
      <button
        type="button"
        onClick={() => setDropdownOpen(!dropdownOpen)}
        className={`w-full py-2 px-1 rounded text-left text-[15px] overflow-y-auto border border-[#19039E] bg-white/5 text-white backdrop-blur-md`}
      >
    <div
  className="text-white mt-1 text-[15px] overflow-y-auto max-h-[4.5rem] pr-1"
  style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}
>
  {Array.isArray(value) && value.length > 0 ? value.join(", ") : "Select Industry Report"}
</div>


      </button>

      {dropdownOpen && (
        <div className="absolute z-20 w-full mt-1 max-h-80 overflow-y-auto rounded border border-white/10 bg-white/10 backdrop-blur-lg shadow-md text-white">


    <div className="flex items-center justify-between px-3 py-2 border-b border-white/10 sticky top-0 z-20 bg-[#361b63]">
      <span className="text-[15px] font-semibold text-white">Select Industry Report</span>
      <button
        type="button"
        onClick={() => setDropdownOpen(false)}
        className="text-white text-[14px] px-3 py-1 rounded bg-[#4f318a] hover:bg-[#3e2670] transition "
      >
        Done
      </button>
    </div>

          {industryOptions.map((group) => (
            <div key={group.label} className="py-2">
              <div className="text-[15px] text-white/50 font-semibold mb-1 uppercase select-none cursor-not-allowed px-3 backdrop-blur-lg sticky top-[45px] z-10 bg-[#361b63]" >
                {group.label}
              </div>
              {group.options
                .sort((a, b) => a.localeCompare(b))
                .map((option) => (
                  <label
                    key={option}
                    className="flex items-center gap-2 py-1 px-3 text-[15px] cursor-pointer hover:bg-white/20 rounded"
                  >
                    <input
                      type="checkbox"
                      className="hidden"
                      checked={value.includes(option)}
                      onChange={() => toggleSelect(option)}
                    />
                    <div
                      className={`h-4 w-4 border border-white/50 rounded-sm flex items-center justify-center ${
                        value.includes(option)
                          ? "bg-transparent"
                          : "bg-transparent"
                      }`}
                    >
                      {value.includes(option) && (
                        <svg
                          className="w-3 h-3 text-white"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      )}
                    </div>
                    <span className="truncate">{option}</span>
                  </label>
                ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default IndustryMultiSelect;

